import classNames from 'classnames';
import { DetailedHTMLProps, FormHTMLAttributes, useState } from 'react';
import fullWidthCard from '../../styles/full-width-card.module.css';
import { HttpError, useRequest } from '../../utils/make-api-request';
import ButtonWithFeedback from '../button-with-feedback';
import { useErrorNotifier } from '../../utils/hooks';

interface Props {
  header: string;
  /**
   * The request body to send to the server to log in.
   */
  loginData: object;
  /**
   * The session endpoint that will be POSTed to to create a session.
   */
  endpoint: string;
  onLogin: () => void;
}

const LoginContainer: React.FC<Props & DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>> = ({
  header,
  endpoint,
  loginData,
  onLogin,
  children
}) => {
  const [incorrect, setIncorrect] = useState(false);
  const [loginRequest, login] = useRequest(endpoint, 'post');
  const showErrorNotification = useErrorNotifier();
  function submit() {
    setIncorrect(false);
    login(loginData).then(onLogin, err => {
      if (err instanceof HttpError && err.status === 401) {
        setIncorrect(true);
      } else {
        showErrorNotification(err);
      }
    });
  }
  return (
    <form
      className={fullWidthCard.fullWidthCard}
      onSubmit={e => {
        e.preventDefault();
        submit();
      }}
    >
      <h1 className='select-none text-xl'>{header}</h1>
      {children}
      <div className={classNames('text-red-300 text-sm', !incorrect && 'hidden')}>Incorrect login credentials</div>
      <div className='flex justify-end mt-2'>
        <ButtonWithFeedback type='submit' className='primary instant-touch' request={loginRequest}>
          Log in
        </ButtonWithFeedback>
      </div>
    </form>
  );
};

export default LoginContainer;
